import type { JobStatus } from "../types/job";
import { STATUS_LABELS, STATUS_TONES, STATUS_TONE_CLASSES } from "../utils/format";

export default function StatusBadge({ status }: { status: JobStatus }) {
    const tone = STATUS_TONES[status];
    return (
        <span
            className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${STATUS_TONE_CLASSES[tone]}`}
        >
            {STATUS_LABELS[status]}
        </span>
    );
}
